const COMMUNITY_WIKI_ROUTER_PREFIX = 'CommunityWiki-';

export {COMMUNITY_WIKI_ROUTER_PREFIX}